import { render, staticRenderFns } from "./PriorityBadge.vue?vue&type=template&id=e4baed54&scoped=true"
import script from "./PriorityBadge.vue?vue&type=script&lang=js"
export * from "./PriorityBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4baed54",
  null
  
)

export default component.exports